import { FAILURE } from 'flaivy-react/reducers/action-type';
import Cookies from 'js-cookie';
import { TOKEN_KEY } from '../../config/api';
import getAxiosInstance from '../../config/api';
import { endImpersonation as getNewToken } from './generated/user.actions';

import { ACTION_TYPES } from '../reducers/auth.reducer';

const removeAuthToken = () => {
  Cookies.remove(TOKEN_KEY);
};

export const displayAuthError = message => ({
  type: ACTION_TYPES.ERROR_MESSAGE,
  message,
});

export const getProfile = req => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.GET_SESSION,
    payload: getAxiosInstance(req).get('/users/me'),
  });
};

export const login = (email, password) => async dispatch => {
  removeAuthToken();

  try {
    const tokenRequest = await getAxiosInstance().post('users/login', {
      email,
      password,
    });

    const jwt = tokenRequest.data.token;
    Cookies.set(TOKEN_KEY, jwt);
  } catch (e) {
    dispatch({
      type: FAILURE(ACTION_TYPES.LOGIN),
      payload: e,
    });
    return;
  }

  await dispatch({
    type: ACTION_TYPES.LOGIN,
    payload: getAxiosInstance().get('users/me'),
  });
};

export const changeActiveOrganization = (params, result) => () => {
  const { token } = result;
  removeAuthToken();
  Cookies.set(TOKEN_KEY, token);
  if (localStorage) {
    localStorage.clear();
  }

  window.location.href = '/app';
};
export const endImpersonation = async () => {
  const token = (await getNewToken({})).data?.token;

  removeAuthToken();
  Cookies.set(TOKEN_KEY, token);
  if (localStorage) {
    localStorage.clear();
  }

  window.location.href = '/app';
};

export const logout = () => dispatch => {
  removeAuthToken();
  dispatch({
    type: ACTION_TYPES.LOGOUT,
  });
  window.location.href = '/';
};

export function clearAuthentication() {
  removeAuthToken();
}
